"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = log;
exports.warn = warn;
exports.error = error;

function log() {
  if (console) {
    var _console;

    (_console = console).log.apply(_console, arguments);
  }
}

function warn() {
  if (console) {
    var _console2;

    (_console2 = console).warn.apply(_console2, arguments);
  }
}

function error() {
  if (console) {
    var _console3;

    (_console3 = console).error.apply(_console3, arguments);
  }
}

exports.default = {
  log: log,
  warn: warn,
  error: error
};